import React, { useEffect } from "react";
import { processResponse } from "../utils/auth";

// /login/callback — die Rueckleitung des IdP (docs/02-konzept.md §3.2).
//
// Der Code steht im Fragment (response_mode=fragment) und verlaesst den
// Browser damit nie. processResponse tauscht ihn mit dem code_verifier gegen
// das ID-Token, prueft die nonce und leitet dorthin zurueck, wo die Anmeldung
// begonnen hat.
//
// Frueher stand hier nur ein Hinweistext: MSAL hat die Rueckleitung selbst
// beim Start der Anwendung abgeraeumt (handleRedirectPromise). Ohne MSAL ist
// diese Route ein echter Schritt und kein Zwischenbild mehr.

export default function LoginCallback() {
  useEffect(() => {
    void processResponse();
  }, []);

  return (
    <div className="container py-5 text-center">
      <div className="spinner-border mb-3" role="status" aria-label="lädt" />
      <h1 className="h5">Anmeldung wird abgeschlossen …</h1>
    </div>
  );
}
